import crypto from 'crypto'

export const uuId = () => crypto.randomBytes(16).toString('hex')
